
{
  "familyId": "MET-MEETK-OPP",
  "questions": [
    {
      "id": "MET-MEETK-OPP-001",
      "familyId": "MET-MEETK-OPP",
      "module": "Metriek",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_opp_cirkel",
      "questionType": "multiple_choice",
      "question": "Een cirkel heeft een straal van 5 cm. Wat is de oppervlakte? (gebruik π ≈ 3,14)",
      "context": null,
      "options": ["78,5 cm²", "31,4 cm²", "15,7 cm²", "25 cm²"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "circle",
          "data": {
            "radius": 5,
            "highlightRadius": true,
            "label": "Cirkel met straal 5 cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte cirkel",
            "content": "Oppervlakte = π × straal². Dus: 3,14 × 5² = 3,14 × 25 = 78,5 cm². Let op: je moet de straal eerst kwadrateren (5² = 25)!"
          }
        }
      ],
      "conceptId": "circle_area_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De formule voor de oppervlakte van een cirkel is: oppervlakte = π × straal². Waarom kwadrateren? Omdat je de straal in twee richtingen vermenigvuldigt (lengte × breedte van het 'vierkant' rond de cirkel). Dus: 3,14 × 5² = 3,14 × 25 = 78,5 cm². Controleer: 78,5 is iets meer dan 3 × 25 = 75 ✓.",
        "solutionSteps": [
          "Schrijf de formule op: oppervlakte = π × straal²",
          "Kwadrateer de straal: 5² = 5 × 5 = 25",
          "Vermenigvuldig met π: 3,14 × 25 = 78,5 cm²",
          "Controleer: 78,5 is iets meer dan 3 × 25 = 75 ✓"
        ],
        "distractorExplanations": {
          "0": "Perfect! 3,14 × 25 = 78,5 cm².",
          "1": "Je hebt waarschijnlijk de omtrek berekend (2 × π × straal = 2 × 3,14 × 5 = 31,4). Maar de vraag is naar de oppervlakte. Oppervlakte = π × straal² = 3,14 × 25 = 78,5 cm². Onthoud: omtrek = 2πr, oppervlakte = πr².",
          "2": "Je bent waarschijnlijk vergeten de straal te kwadrateren. De formule is π × straal² = 3,14 × 25 (niet 3,14 × 5 = 15,7). Onthoud: de straal moet in het kwadraat!",
          "3": "Je hebt waarschijnlijk alleen de straal gekwadrateerd (5² = 25) maar vergat met π te vermenigvuldigen. De volledige formule is: 3,14 × 25 = 78,5 cm². Onthoud: π mag niet vergeten worden."
        }
      }
    },
    {
      "id": "MET-MEETK-OPP-002",
      "familyId": "MET-MEETK-OPP",
      "module": "Metriek",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_opp_cirkel",
      "questionType": "multiple_choice",
      "question": "De diameter van een cirkel is 10 cm. Wat is de oppervlakte? (gebruik π ≈ 3,14)",
      "context": null,
      "options": ["78,5 cm²", "31,4 cm²", "314 cm²", "100 cm²"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "circle",
          "data": {
            "diameter": 10,
            "highlightDiameter": true,
            "label": "Cirkel met diameter 10 cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte cirkel met diameter",
            "content": "Eerst de straal berekenen: straal = diameter ÷ 2 = 10 ÷ 2 = 5 cm. Dan: oppervlakte = π × straal² = 3,14 × 5² = 3,14 × 25 = 78,5 cm²."
          }
        }
      ],
      "conceptId": "circle_area_diameter",
      "variantIndex": 2,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Eerst de straal berekenen: diameter ÷ 2 = 10 ÷ 2 = 5 cm. Dan de oppervlakte: π × straal² = 3,14 × 5² = 3,14 × 25 = 78,5 cm². Waarom eerst de straal? De oppervlakteformule werkt alleen met de straal, niet met de diameter. Controleer: π × 10² = 314 zou veel te groot zijn ✓.",
        "solutionSteps": [
          "Bereken de straal uit de diameter: straal = diameter ÷ 2 = 10 ÷ 2 = 5 cm",
          "Schrijf de formule op: oppervlakte = π × straal²",
          "Kwadrateer de straal: 5² = 25",
          "Vermenigvuldig met π: 3,14 × 25 = 78,5 cm²"
        ],
        "distractorExplanations": {
          "0": "Uitstekend! Straal = diameter ÷ 2 = 5 cm, dan oppervlakte = π × 5² = 3,14 × 25 = 78,5 cm².",
          "1": "Je hebt waarschijnlijk de omtrek berekend (π × diameter = 3,14 × 10 = 31,4). Maar de vraag is naar de oppervlakte. Bereken eerst de straal (5 cm), dan: π × 5² = 78,5 cm². Onthoud: oppervlakte = πr².",
          "2": "Je hebt waarschijnlijk de diameter gekwadrateerd (π × 10² = 314). Maar je moet eerst de straal berekenen: straal = 10 ÷ 2 = 5, dan π × 5² = 78,5 cm². Onthoud: altijd eerst straal berekenen!",
          "3": "Je hebt waarschijnlijk alleen de diameter gekwadrateerd (10² = 100) zonder π. De volledige berekening: straal = 5, dan π × 5² = 3,14 × 25 = 78,5 cm². Onthoud: gebruik de straal en vergeet π niet."
        }
      }
    },
    {
      "id": "MET-MEETK-OPP-003",
      "familyId": "MET-MEETK-OPP",
      "module": "Metriek",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_opp_cirkel",
      "questionType": "multiple_choice",
      "question": "Een cirkel heeft een oppervlakte van 314 cm². Wat is ongeveer de straal? (gebruik π ≈ 3,14)",
      "context": null,
      "options": ["10 cm", "100 cm", "5 cm", "20 cm"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "circle",
          "data": {
            "radius": 10,
            "label": "Cirkel met oppervlakte 314 cm²"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Straal berekenen uit oppervlakte",
            "content": "Oppervlakte = π × straal². Dus: straal² = oppervlakte ÷ π = 314 ÷ 3,14 = 100. Dan: straal = √100 = 10 cm."
          }
        }
      ],
      "conceptId": "circle_radius_from_area",
      "variantIndex": 3,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.65,
      "feedback": {
        "explanationText": "Oppervlakte = π × straal². Draai de formule om: straal² = oppervlakte ÷ π = 314 ÷ 3,14 = 100. Trek de wortel: straal = √100 = 10 cm. Controleer: π × 10² = 3,14 × 100 = 314 ✓. Onthoud: bij het terugrekenen deel je eerst door π en trek je dan de wortel.",
        "solutionSteps": [
          "Schrijf de formule op: oppervlakte = π × straal²",
          "Draai de formule om: straal² = oppervlakte ÷ π",
          "Vul in en deel: straal² = 314 ÷ 3,14 = 100",
          "Trek de wortel: straal = √100 = 10 cm"
        ],
        "distractorExplanations": {
          "0": "Goed gedaan! Straal² = 314 ÷ 3,14 = 100, dus straal = √100 = 10 cm. Controleer: π × 10² = 314 ✓.",
          "1": "Je hebt waarschijnlijk straal² berekend (314 ÷ 3,14 = 100) maar vergat de wortel te trekken. Straal = √100 = 10 cm, niet 100 cm. Onthoud: na het delen door π moet je nog de wortel trekken.",
          "2": "Je hebt waarschijnlijk 314 ÷ 62,8 gedaan (of een andere fout). De juiste berekening is: 314 ÷ 3,14 = 100, dan √100 = 10 cm. Onthoud: deel door π (3,14), niet door 2π.",
          "3": "Je hebt waarschijnlijk de diameter berekend in plaats van de straal. De straal = 10 cm, de diameter zou 20 cm zijn. Onthoud: de formule geeft de straal, niet de diameter."
        }
      }
    },
    {
      "id": "MET-MEETK-OPP-004",
      "familyId": "MET-MEETK-OPP",
      "module": "Metriek",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_opp_cirkel",
      "questionType": "multiple_choice",
      "question": "Een pizzabakker snijdt een pizza met een diameter van 30 cm doormidden. Wat is de oppervlakte van een halve pizza? (gebruik π ≈ 3,14)",
      "context": "Een pizzabakker snijdt pizza's voor klanten.",
      "options": ["353,25 cm²", "706,5 cm²", "94,2 cm²", "225 cm²"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "circle",
          "data": {
            "radius": 15,
            "highlightRadius": true,
            "label": "Pizza ∅ 30 cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Halve cirkel",
            "content": "Stap 1: straal = diameter ÷ 2 = 30 ÷ 2 = 15 cm. Stap 2: hele oppervlakte = π × 15² = 3,14 × 225 = 706,5 cm². Stap 3: halve pizza = 706,5 ÷ 2 = 353,25 cm²."
          }
        }
      ],
      "conceptId": "circle_area_half",
      "variantIndex": 4,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Eerst de straal: diameter ÷ 2 = 30 ÷ 2 = 15 cm. Dan de hele oppervlakte: π × straal² = 3,14 × 15² = 3,14 × 225 = 706,5 cm². Een halve pizza is de helft: 706,5 ÷ 2 = 353,25 cm². Waarom eerst de hele cirkel? Het is makkelijker om eerst de hele oppervlakte te berekenen en dan te halveren. Controleer: 353,25 × 2 = 706,5 ✓.",
        "solutionSteps": [
          "Bereken de straal: diameter ÷ 2 = 30 ÷ 2 = 15 cm",
          "Bereken de hele oppervlakte: π × straal² = 3,14 × 15² = 3,14 × 225 = 706,5 cm²",
          "Halveer voor de halve pizza: 706,5 ÷ 2 = 353,25 cm²",
          "Controleer: 353,25 × 2 = 706,5 ✓"
        ],
        "distractorExplanations": {
          "0": "Uitstekend! Straal = 15 cm, hele opp = 3,14 × 225 = 706,5 cm², halve pizza = 353,25 cm².",
          "1": "Je hebt waarschijnlijk de hele pizza berekend (706,5 cm²) maar vergat te halveren. De vraag is naar een halve pizza: 706,5 ÷ 2 = 353,25 cm². Onthoud: lees goed wat er gevraagd wordt.",
          "2": "Je hebt waarschijnlijk de halve omtrek berekend in plaats van de halve oppervlakte. Oppervlakte = π × straal² = 3,14 × 225 = 706,5, gehalveerd = 353,25 cm². Onthoud: oppervlakte = πr², niet 2πr.",
          "3": "Je hebt waarschijnlijk alleen de straal gekwadrateerd (15² = 225) zonder π en zonder te halveren. De volledige berekening: 3,14 × 225 = 706,5, gehalveerd = 353,25 cm²."
        }
      }
    },
    {
      "id": "MET-MEETK-OPP-005",
      "familyId": "MET-MEETK-OPP",
      "module": "Metriek",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_opp_cirkel",
      "questionType": "multiple_choice",
      "question": "Een tuinier legt een ronde vijver aan met een straal van 4 meter. Om de vijver komt een pad van 1 meter breed. Wat is de oppervlakte van alleen het pad? (gebruik π ≈ 3,14)",
      "context": "Een tuinier ontwerpt een vijver met een pad eromheen.",
      "options": ["28,26 m²", "78,5 m²", "50,24 m²", "12,56 m²"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "circle",
          "data": {
            "radius": 5,
            "highlightRadius": true,
            "label": "Vijver (r=4) + pad (1m breed)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Ring (annulus) berekenen",
            "content": "Grote cirkel (vijver + pad): straal = 4 + 1 = 5 m, opp = 3,14 × 25 = 78,5 m². Kleine cirkel (vijver): straal = 4 m, opp = 3,14 × 16 = 50,24 m². Pad = groot − klein = 78,5 − 50,24 = 28,26 m²."
          }
        }
      ],
      "conceptId": "circle_area_ring",
      "variantIndex": 5,
      "citoDifficulty": 0.56,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Dit is een ringvormig pad. Bereken twee cirkels en trek ze van elkaar af. Grote cirkel (vijver + pad): straal = 4 + 1 = 5 m, oppervlakte = 3,14 × 5² = 78,5 m². Kleine cirkel (alleen vijver): straal = 4 m, oppervlakte = 3,14 × 4² = 50,24 m². Het pad = groot − klein = 78,5 − 50,24 = 28,26 m². Controleer: 28,26 + 50,24 = 78,5 ✓.",
        "solutionSteps": [
          "Bepaal de straal van de grote cirkel (vijver + pad): 4 + 1 = 5 m",
          "Bereken de grote oppervlakte: π × 5² = 3,14 × 25 = 78,5 m²",
          "Bereken de kleine oppervlakte (vijver): π × 4² = 3,14 × 16 = 50,24 m²",
          "Trek af: pad = 78,5 − 50,24 = 28,26 m²",
          "Controleer: 28,26 + 50,24 = 78,5 ✓"
        ],
        "distractorExplanations": {
          "0": "Uitstekend! Grote cirkel = 78,5 m², kleine cirkel = 50,24 m², pad = 78,5 − 50,24 = 28,26 m².",
          "1": "Je hebt waarschijnlijk alleen de grote cirkel berekend (π × 5² = 78,5 m²). Maar dat is vijver + pad samen. Trek de vijver eraf: 78,5 − 50,24 = 28,26 m². Onthoud: ring = groot − klein.",
          "2": "Je hebt waarschijnlijk alleen de vijver berekend (π × 4² = 50,24 m²). Maar de vraag is naar het pad. Bereken de grote cirkel (78,5) en trek de vijver af: 78,5 − 50,24 = 28,26 m².",
          "3": "Je hebt waarschijnlijk de omtrek berekend in plaats van de oppervlakte, of alleen het verschil in straal gebruikt. De juiste aanpak: twee oppervlaktes berekenen en aftrekken: 78,5 − 50,24 = 28,26 m²."
        }
      }
    }
  ]
}
